let offers;
let theProduct;

function wait(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function getCurrentlySelectedVariant(product) {
  mulberryShop.selectedVariantId = document
    .querySelector('.check-all-temp')
    ?.closest('form')
    ?.querySelector('[name="id"]')
    ?.value || mulberryShop.selectedVariantId;

  let selectedVariant = product.variants.find(
    (i) => i.id == mulberryShop.selectedVariantId
  );

  if (!selectedVariant) {
    selectedVariant = product.variants[0];
  }

  let priceEl = document.querySelector('.single-product-price');

  if (priceEl) {
    let price = Number(priceEl.textContent.replace(/[^\d.]/g, ''));
    price = Number.isNaN(price) ? null : price.toFixed(2);

    if (price) {
      selectedVariant.price = price.toString();
    }
  } else {
    priceEl = document.querySelector('#payment-price');

    if (priceEl) {
      let price = Number(priceEl.textContent.replace(/[^\d.]/g, ''));
      price = Number.isNaN(price) ? null : price.toFixed(2);

      if (price) {
        selectedVariant.price = price.toString();
      }
    }
  }

  return selectedVariant;
}

async function mulberryPdpInit() {
  const HAS_MODAL = mulberry.core.settings.has_modal;
  const HAS_INLINE = mulberry.core.settings.has_inline || true;

  if (window.location.pathname.indexOf("/products/") === -1) {
    return;
  }

  if (!HAS_MODAL && !HAS_INLINE) {
    return;
  }

  const mulberryDiv = document.createElement('div');
  mulberryDiv.classList.add('mulberry-pdp-inline');
  mulberryDiv.style = "min-height: 100px;";

  document.querySelector('.mulberry-box')?.appendChild(mulberryDiv);

  let response = await mulberryShop.getProductData(
    mulberryShop.getProductUrl()
  );

  theProduct = response.product;

  let selectedVariant = getCurrentlySelectedVariant(theProduct);

  offers = await mulberry.core.getWarrantyOffer({
    id: selectedVariant.id,
    title: theProduct.title,
    price: selectedVariant.price,
    detail: theProduct,
  });

  if (HAS_INLINE) {
    window.pdpInline = await mulberry.inline.init({
      offers: offers,
      settings: mulberry.core.settings,
      selector: ".mulberry-pdp-inline",
      layout: {
        faq: false,
      },
      onWarrantyToggle: async (warranty) => {
        mulberry.inline.isSelected = warranty.isSelected;

        if (warranty.isSelected) {
          window.selectedOffer = warranty;
        } else {
          window.selectedOffer = null;
        }
      },
    });
    mulberry.faq.init({
      coverage: mulberry.core.offers[0],
      settings: mulberry.core.settings
    })
    document.querySelector("#whats-covered-faq").removeAttribute("style")
    document.querySelector("#whats-covered-faq")?.addEventListener("click",function(){
      mulberry.faq.open();
    });
  }

  if (HAS_MODAL) {
    window.pdpModal = await mulberry.modal.init({
      offers: offers,
      settings: mulberry.core.settings,
      onWarrantySelect: async (warranty) => {
        const result = await mulberryShop.getWarrantyVariant(warranty);

        await mulberryShop.addWarrantyToCart(
          result.shopify_variant_id,
          theProduct,
          warranty
        );

        document.querySelector(".last-form .check-all")?.click();
        mulberry.modal.close();
      },
      onWarrantyDecline: async () => {
        document.querySelector(".last-form .check-all")?.click();
        mulberry.modal.close();
      },
    });
  }
}

document
  ?.querySelector(".last-form .check-all-temp")
  ?.addEventListener("click", async function (e) {
    e.preventDefault();

    const HAS_MODAL = mulberry.core.settings.has_modal;
    const HAS_INLINE = mulberry.core.settings.has_inline || true;

    const spinner = this.querySelector(".loading__spinner");

    if (spinner) {
      spinner.classList.remove("hidden");
    }

    this.disabled = true;

    const handleClick = async () => {
      if (HAS_INLINE && window.selectedOffer && window.pdpInline) {
        await addWarranty();
      } else if (HAS_MODAL && !window.selectedOffer && window.pdpModal) {
        window.pdpModal.open();
      } else {
        document.querySelector(".last-form .check-all")?.click();
      }
    };

    await Promise.resolve().then(handleClick);

    this.disabled = false;
  });

async function addWarranty() {
  addToCartButtonClicked = true;

  if (!offers || offers.length == 0) {
    return;
  }

  try {
    let result;

    cart = await fetch("/cart.js");
    cartJson = await cart.json();

    if (window.selectedOffer) {
      result = await mulberryShop.getWarrantyVariant(
        window.selectedOffer.offer
      );

      const final = await mulberryShop.addWarrantyToCart(
        result.shopify_variant_id,
        {
          ...theProduct,
          title: theProduct.title,
          variantId: mulberryShop.selectedVariantId,
        },
        window.selectedOffer.offer
      );

      document.querySelector(".last-form .check-all")?.click();

      window.pdpInline.deselectOffer();
      window.selectedOffer = null;
    }
  } catch (err) {
    console.log("mulberry error: ", err);
  }

  mulberry.inline.deselectOffer();
}

document.addEventListener('mulberry-shopify:warranty-added', async (e) => {
  // await removeAndSyncWarranties();
});

document.addEventListener("mulberry-shopify:loaded", async function (e) {
  window.mb_gtm_is_disabled = true;

  setupFetchListeners();

  if (document.location.href.includes("/products/")) {
    await mulberryPdpInit();
  }

  let theVariant;
  let variantChangeToken = 0;
  let variantRefreshTimer;
  let lastKnownVariantId = '';

  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);

    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  function getCurrentVariantId() {
    return (
      getUrlParameter('variant') ||
      document
        .querySelector('.check-all-temp')
        ?.closest('form')
        ?.querySelector('[name="id"]')
        ?.value ||
      ''
    );
  }

  async function handleUrlChange(force = false) {
    var variant = getCurrentVariantId();

    if (variant && (force || theVariant !== variant) && window.pdpInline) {
      const token = ++variantChangeToken;

      theVariant = variant;

      window.selectedOffer = null;
      window.pdpInline.deselectOffer();

      mulberryShop.selectedVariantId = variant;

      // Wait for theme price DOM to finish updating
      await wait(900);

      // Ignore stale execution if user changed variant again quickly
      if (token !== variantChangeToken) {
        return;
      }

      let selectedVariant = getCurrentlySelectedVariant(theProduct);

      offers = await mulberry.core.getWarrantyOffer({
        id: selectedVariant.id,
        title: theProduct.title,
        price: selectedVariant.price,
        detail: theProduct,
      });

      if (offers && offers.length) {
        document.querySelector('.mulberry-box').style.display = 'block';

        if (mulberry.core.settings.has_inline) {
          window.pdpInline.updateOffer(offers);
        }

        if (mulberry.core.settings.has_modal) {
          window.pdpModal.updateOffer(offers);
        }
      } else {
        document.querySelector('.mulberry-box').style.display = 'none';
      }
    }
  }

  function triggerVariantRefresh(force = false) {
    clearTimeout(variantRefreshTimer);

    variantRefreshTimer = setTimeout(() => {
      handleUrlChange(force);
    }, 50);
  }

  function patchHistoryChange() {
    if (window.__mulberryHistoryPatched) return;

    window.__mulberryHistoryPatched = true;

    ['pushState', 'replaceState'].forEach(function (method) {
      const original = history[method];

      history[method] = function () {
        const result = original.apply(this, arguments);

        window.dispatchEvent(new Event('mulberry:urlchange'));

        return result;
      };
    });

    window.addEventListener('popstate', function () {
      window.dispatchEvent(new Event('mulberry:urlchange'));
    });
  }

  patchHistoryChange();

  window.addEventListener('mulberry:urlchange', function () {
    triggerVariantRefresh(false);
  });

  document.querySelector('.chiller-variant-container')?.addEventListener('click', function (event) {
    const chillerItem = event.target.closest('.chiller-variant-item');

    if (chillerItem) {
      const clickedOptionValue = getOptionValueFromCard(chillerItem);

      updateVariantFromClickedOption(clickedOptionValue);

      setTimeout(function () {
        triggerVariantRefresh(true);
      }, 300);
    }
  });

  // This is the important fallback.
  // It watches actual Shopify variant input, not only URL.
  lastKnownVariantId = getCurrentVariantId();

  if (!window.__mulberryVariantWatcherStarted) {
    window.__mulberryVariantWatcherStarted = true;

    setInterval(function () {
      const currentVariantId =
        getUrlParameter('variant') ||
        document
          .querySelector('.check-all-temp')
          ?.closest('form')
          ?.querySelector('[name="id"]')
          ?.value ||
        '';

      if (currentVariantId && currentVariantId !== lastKnownVariantId) {
        lastKnownVariantId = currentVariantId;
        triggerVariantRefresh(true);
      }
    }, 300);
  }

  handleUrlChange(true);
});

document.addEventListener("fetch:cart-change", async function () {
  await removeAndSyncWarranties();
});

document.addEventListener("fetch:cart-add", async function () {
  // await removeAndSyncWarranties();
});

async function removeAndSyncWarranties(reload = false) {
  let response = await fetch('/cart.js', {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  });

  let firstCart = await response.json();
  const originalItemCount = firstCart.item_count;

  firstCart.items = firstCart.items.filter(
    item => item?.properties?._variantId !== 'sectional'
  );

  try {
    const newCart = await mulberryShop.removeDetachedWarranty(firstCart);
    const updatedCart = await mulberryShop.cart.syncQuantities(newCart);

    document.querySelector('cart-drawer')?.refreshContents();

    if (updatedCart && updatedCart.items && !updatedCart.items.length) {
      document.querySelector('.drawer.active')?.classList.add('is-empty');

      const bubble = document.querySelector(".cart-count-bubble");
      const visibleSpan = bubble.querySelector('span[aria-hidden="true"]');
      const hiddenSpan = bubble.querySelector('.visually-hidden');

      if (visibleSpan) visibleSpan.textContent = 0;
      if (hiddenSpan) hiddenSpan.textContent = `0 items`;
    }

  } catch (error) {
    console.error('Error during warranty removal and cart sync:', error);
  }
}

function setupFetchListeners() {
  if (window.__mulberryFetchPatched) return;
  window.__mulberryFetchPatched = true;

  const { fetch: origFetch } = window;

  window.fetch = async (...args) => {
    const response = await origFetch(...args);

    let requestUrl = args[0];

    if (typeof requestUrl !== 'string') {
      requestUrl = requestUrl?.url || '';
    }

    if (
      requestUrl.includes("cart/change") ||
      requestUrl.includes("cart/add") ||
      requestUrl.includes("cart/update")
    ) {
      response
        .clone()
        .json()
        .then((body) => {
          if (requestUrl.includes("cart/add")) {
            const fetchAddCustomEvent = new CustomEvent("fetch:cart-add");
            document.dispatchEvent(fetchAddCustomEvent);
          } else if (requestUrl.includes("cart/change")) {
            const fetchChangeCustomEvent = new CustomEvent("fetch:cart-change");
            document.dispatchEvent(fetchChangeCustomEvent);
          } else if (requestUrl.includes("cart/update")) {
            const fetchUpdateCustomEvent = new CustomEvent("fetch:cart-update");
            document.dispatchEvent(fetchUpdateCustomEvent);
          } else {
            if (requestUrl.includes("cart.php")) {
              const fetchCartCustomEvent = new CustomEvent("fetch:cart-page");
              document.dispatchEvent(fetchCartCustomEvent);
            }
          }
        })
        .catch((err) => console.error(err));
    }

    return response;
  };
}

function getOptionValueFromCard(item) {
  return item.querySelector('.chiller-variant-item-title')?.textContent?.trim()
    || item.dataset.value?.trim()
    || '';
}

function normalize(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

function updateVariantFromClickedOption(clickedOptionValue) {
  const variantInput = document
    .querySelector('.check-all-temp')
    ?.closest('form')
    ?.querySelector('[name="id"]');

  if (variantInput) {
    const currentVariantId = Number(variantInput.value);
    const currentVariant = product.variants.find(v => Number(v.id) === currentVariantId);

    if (currentVariant) {
      const clickedNormalized = normalize(clickedOptionValue);

      const optionIndex = product.variants[0].options.findIndex((_, index) => {
        return product.variants.some(variant => {
          return normalize(variant.options[index]) === clickedNormalized;
        });
      });

      if (optionIndex > -1) {
        const nextOptions = [...currentVariant.options];
        nextOptions[optionIndex] = clickedOptionValue;

        const matchedVariant = product.variants.find(variant => {
          return variant.options.every((option, index) => {
            return normalize(option) === normalize(nextOptions[index]);
          });
        });

        if (matchedVariant) {
          variantInput.value = matchedVariant.id;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));

          const url = new URL(window.location.href);
          url.searchParams.set('variant', matchedVariant.id);

          window.history.replaceState({}, '', url.toString());
        }
      }
    }
  }
}